import React, { FC } from 'react';
import './PropertyForm.css';

import { SingleValue } from 'react-select';
import {
	CreateButton,
	InputField,
	SelectField,
	TextAreaField,
	FaCalendarAlt,
	FaBuilding,
	FaCity,
	FaMoneyBillAlt,
	MediaURL,
	UPLOAD_MAX_MEDIA_SIZE,
	UPLOAD_MAX_FILES,
	CheckBoxField,
	MediaPreview,
	RequiredNote,
	URLField,
	MediaField,
	FaUser,
	FaCheckCircle,
	SelectOptionType,
	DomainFormProps,
	UIFeedbackHooks,
	SoNumber,
	Alert,
	MessageHelper,
	FeedBackType
} from '@/Shared';
import { PropertyFormViewModel } from '../../Logic';




/**
 * =====================================================
 * Component: ActivityForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Activity.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render activity fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const PropertyForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { values, setFieldValue } = formikProps;

	const entityFormVM = domainFormHook.entityFormVM as PropertyFormViewModel;
	const uiFeedbackHooks = domainFormHook.uiFeedbackHooks as UIFeedbackHooks;

	const { lightBoxHook, confirmHook } = uiFeedbackHooks;

	if(!lightBoxHook) {
		return <Alert data={{
			title : MessageHelper.TECHNICAL.MISSING_HOOK.TITLE,
			message : MessageHelper.TECHNICAL.MISSING_HOOK.MESSAGE,
			type : FeedBackType.ERROR
		}} />
	}

	const hasImages = values.images.length > 0;
	

	const selectedVideos = (values.videos as MediaURL[]).filter(video => video.url.length > 0);
	const hasVideos = selectedVideos.length > 0;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (
		<div className="fieldset-wrapper">

			<fieldset className='width-30'>
				<legend>Caractéristiques Générales</legend>
				{/** 
				<SelectField
					label='Mandat'
					icon={<FaFileInvoice />}
					name='mandateId'
					options={entityFormVM.getMandateOptions()}
					scrollParent={formRef.current}
				/>*/}
				<SelectField
					label="Type d'opération"
					required
					icon={<FaMoneyBillAlt />}
					name='operationType'
					options={entityFormVM.operationOptions}
					scrollParent={formRef.current}
					placeholder="Choisir le type d'opération"
				/>
				<SelectField
					label="Propriétaire(s)"
					icon={<FaUser />}
					name='owners'
					options={entityFormVM.ownerOptions}
					scrollParent={formRef.current}
					isMulti
					placeholder="Choisir un propriétaire"
				/>
				<SelectField
					label='Nature du bien'
					required
					icon={<FaBuilding />}
					name='propertyCategory'
					options={entityFormVM.categoryOptions}
					scrollParent={formRef.current}
					placeholder='Choisir la nature du bien'
					onChange={

						(selectedOption) => {

							const firstValue = entityFormVM.handleCategoryChange(
								(selectedOption as SingleValue<SelectOptionType>)?.value as string);

							setFieldValue('propertyType', firstValue);
						}
					}
				/>
				<SelectField
					label='Type du bien'
					icon={<FaBuilding />}
					name='propertyType'
					options={entityFormVM.typeOptions}
					scrollParent={formRef.current}
					placeholder="Choisir un type de bien"
				/>
				<SelectField
					label='Usage'
					icon={<FaBuilding />}
					name='usageType'
					options={entityFormVM.propertyUsageOptions}
					placeholder="Choisir un usage"
					scrollParent={formRef.current}
				/>

				<SelectField
					label='Etat Général'
					required
					icon={<FaBuilding />}
					name='condition'
					options={entityFormVM.conditionOptions}
					scrollParent={formRef.current}
					placeholder="Choisir condition général"
				/>

				<InputField
					label='Année de construction'
					icon={<FaCalendarAlt />}
					name='yearBuilt'
					type='number'
					autoComplete='on' />

				<CheckBoxField
					label='Meublé'
					name='furnished'
				/>

				<RequiredNote />
			</fieldset>
			<fieldset className='width-30'>
				<legend>Disponibilité & Adresse</legend>
				<SelectField
					label='Disponibilité'
					required
					icon={<FaBuilding />}
					name='availability'
					options={entityFormVM.availabilityOptions}
					scrollParent={formRef.current}
					placeholder="Choisir la disponibilité"
				/>
				<InputField
					label='Disponible le'
					icon={<FaCalendarAlt />}
					name='availableAt'
					type='date'
					autoComplete='date' />

				<SelectField
					label='Ville'
					required
					icon={<FaCity />}
					name='cityId'
					options={entityFormVM.cityOptions}
					scrollParent={formRef.current}
					onChange={
						(selectedOption) => {
							const firstValue = entityFormVM.handleCityChange(
								(selectedOption as SingleValue<SelectOptionType>)?.value);

							setFieldValue('sectorId', firstValue);
						}
					}
					placeholder='Choisir la ville du bien'
				/>
				<SelectField
					label='Secteur'
					required
					icon={<FaCity />}
					name='sectorId'
					options={entityFormVM.sectorOptions}
					scrollParent={formRef.current}
					placeholder='Choisir le secteur du bien'
				/>
				<TextAreaField
					label='Adresse'
					required
					name="address"
					placeholder={"Saisir l'adresse du bien"}
				/>
				<RequiredNote />
			</fieldset>
			<fieldset className='width-30' >
				<legend>Description & Pièces</legend>
				<SelectField
					label='Standing'
					required
					icon={<FaCity />}
					name='standing'
					options={entityFormVM.standingOptions}
					scrollParent={formRef.current}
					placeholder='Choisir le standing du bien'
				/>
				<TextAreaField
					name="description"
					label='Description'
					placeholder={"Saisir la descrption du bien"}
				/>
				<InputField
					label='Nombre de pièces'
					icon={<FaBuilding />}
					name='roomCount'
					placeholder='Saisir le ombre de pièces'
					type='number'
					autoComplete='on' />

				<InputField
					label='Surface'
					icon={<FaBuilding />}
					name='surfaceArea'
					placeholder='Saisir le la surface'
					type='number'
					autoComplete='on' />

				<SelectField
					label='Détails des pièces'
					icon={<FaBuilding />}
					name='amenityFeatures'
					options={entityFormVM.amenityFeatureOptions}
					scrollParent={formRef.current}
					isMulti

				/>
				<SelectField
					label='Préstations'
					icon={<FaCheckCircle />}
					name='serviceFeatures'
					options={entityFormVM.serviceFeatureOptions}
					scrollParent={formRef.current}
					isMulti

				/>
				<RequiredNote />
			</fieldset>

			<fieldset className='width-30 height__fit-content'>
				<legend>éléments financiers</legend>


				<InputField
					label='Prix / loyer Hc'
					required
					icon={<FaMoneyBillAlt />}
					name='price'
					placeholder='Saisir le prix/Loyer hors charges'
					type='text'
					autoComplete='on'
					onChange={
						(e) => {
							const computedValues = entityFormVM.handlePriceChange({
								price: e.target.value,
								serviceChargeProvision: values.serviceChargeProvision,
								acMaintenanceCharge: values.acMaintenanceCharge,
							});
							Object.entries(computedValues).forEach(
								([key, value]) => setFieldValue(key, value)
							);
						}
					}
				/>

				<InputField
					label='Provisions sur charges'
					icon={<FaMoneyBillAlt />}
					name='serviceChargeProvision'
					placeholder='Saisir les charges'
					type='text'
					autoComplete='on'

					onChange={
						(e) => {
							const computedValues = entityFormVM.handleChargeChange({
								serviceChargeProvision: e.target.value,
								acMaintenanceCharge: values.acMaintenanceCharge,
								price: values.price
							});
							Object.entries(computedValues).forEach(
								([key, value]) => setFieldValue(key, value)
							);
						}
					}
				/>

				<InputField
					label='Entretien Climatisation'
					icon={<FaMoneyBillAlt />}
					name='acMaintenanceCharge'
					placeholder='Saisir les charges A/C'
					type='text'
					autoComplete='on'

					onChange={
						(e) => {
							const computedValues = entityFormVM.handleChargeChange({
								acMaintenanceCharge: e.target.value,
								serviceChargeProvision: values.serviceChargeProvision,
								price: values.price
							});
							Object.entries(computedValues).forEach(
								([key, value]) => setFieldValue(key, value)
							);
						}
					}
				/>

				<InputField
					label='Dépôt de garantie'
					icon={<FaMoneyBillAlt />}
					name='securityDeposit'
					placeholder='Saisir le montant du dépôt de garantie'
					type='text'
					autoComplete='on'
					onChange={ 
						(e) => setFieldValue(
							'securityDeposit', 
							SoNumber.formatAmount(e.target.value)
						)
					}
					
				/>

				<InputField
					readOnly
					label='Prix / Loyer total'
					required
					icon={<FaMoneyBillAlt />}
					name='totalPrice'
					placeholder='Prix total calculé'
					type='text'
					autoComplete='on' />


				<InputField
					readOnly
					label='Fourchette de prix'
					required
					icon={<FaMoneyBillAlt />}
					name='priceRangeLabel'
				/>
				<RequiredNote />
			</fieldset>
			<fieldset className='width-30 height__fit-content'>
					<legend>Photos & Vidéos</legend>
					<MediaField
						label={`Photos du bien (${UPLOAD_MAX_FILES} Max)`}
						multiple={true}
						name='images'
						placeholder={`Sélectionner les images (${UPLOAD_MAX_MEDIA_SIZE}Mo Max.)`}
						type='image'
						autoComplete='on'
						fieldValues={values.images}
					/>

					{(values.videos as MediaURL[] ?? []).map((mediaURL, index) =>
						<URLField
						    confirmHook={confirmHook}
							key={mediaURL.url + '' + index}
							index={index}
							label='Vidéo du bien'
							name='videos'
							placeholder={`Saisir Lien vidéo ${index + 1}`}
							fieldValues={values.videos}
						/>
					)}
					<CreateButton
						label='Nouveau lien vidéo'
						onClick={
							() => setFieldValue(
								'videos',
								[...values.videos, new MediaURL('', 'video')],
								true
							)
						}
					/>
			</fieldset>
			
				{hasImages && <MediaPreview
					medias={values.images}
					type='image'
					confirmHook={confirmHook}
					lightBoxHook={lightBoxHook}
				/>
				}
				{hasVideos && <MediaPreview
					medias={selectedVideos}
					type='video'
					confirmHook={confirmHook}
					lightBoxHook={lightBoxHook}
				/>
				}
		</div>
	);
}
export default PropertyForm;